/**
 * RESPONSIBILITY: the @Color control - swatch plus hex field.
 *
 * Registers with a tester + rank. The highest-ranked renderer for a schema node
 * wins, so adding a control is a registration — there is no switch on field type.
 */
import { useState } from 'react';
import { rankWith, and, isStringControl, optionIs, type ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';

function ColorControlBase({ data, handleChange, path, label, errors }: ControlProps) {
  const value = typeof data === 'string' && data ? data : '#000000';
  return (
    <div className="ctl">
      <label className="ctl-label">{label}</label>
      <div className="ctl-color">
        <input type="color" value={value} onChange={(e) => handleChange(path, e.target.value)} />
        <input
          type="text" className="ctl-input mono" value={value}
          onChange={(e) => handleChange(path, e.target.value)}
        />
      </div>
      {errors && <p className="ctl-error">{errors}</p>}
    </div>
  );
}

export const colorControl = {
  tester: rankWith(10, and(isStringControl, optionIs('widget', 'color'))),
  renderer: withJsonFormsControlProps(ColorControlBase),
};

/* -------------------------------------------------------------------------- */
/*  Image — upload lands at /img/<folder>/<hash>.<ext>                         */
